/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlertRuleDto } from '../../models/alert-rule-dto';

export interface AlertsQueryQueryDefinitionIdGet$Json$Params {
  queryDefinitionId: string;
}

export function alertsQueryQueryDefinitionIdGet$Json(http: HttpClient, rootUrl: string, params: AlertsQueryQueryDefinitionIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AlertRuleDto>>> {
  const rb = new RequestBuilder(rootUrl, alertsQueryQueryDefinitionIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('queryDefinitionId', params.queryDefinitionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AlertRuleDto>>;
    })
  );
}

alertsQueryQueryDefinitionIdGet$Json.PATH = '/alerts/query/{queryDefinitionId}';
